
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'Header',
    props: {
        title: String,
        buttonText: String,
        buttonRoute: String,
        hasButton: {
            type: Boolean,
            default: true,
        },
    },
    setup() {
        return {
            
        }
    }
});

